import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { CopyToClipboardComponent } from '@rxap/components';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'td[eurogard-copy-to-clipboard-cell]',
  templateUrl: './copy-to-clipboard-cell.component.html',
  styleUrls: [ './copy-to-clipboard-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CopyToClipboardComponent ],
})
export class CopyToClipboardCellComponent {

  @Input('eurogard-copy-to-clipboard-cell')
  public value: any;

}
